module.exports = __webpack_public_path__ + "img/modal-regist-1.e1cd3522.png";